import { createPendientesPage, defaultSortRows, ESTATUS2_SELECT_FIELD_OPTIONS } from "./PendientesLocalPage";

const normalizeText = (value) =>
  (value ?? "")
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const isQualitasXnuupAseguradora = (value) => {
  const aseguradora = normalizeText(value);
  return (
    aseguradora.includes("qualitas")
    || aseguradora.includes("xnuup")
    || aseguradora.includes("xnuub")
  );
};

const filterQualitasXnuupRows = (rows, localidadObjetivo) => {
  if (!Array.isArray(rows)) return [];

  const localidadNormalizada = normalizeText(localidadObjetivo);

  const filtered = rows.filter((row) => {
    const aseguradora = row?.ASEGURADORA;
    const localidad = normalizeText(row?.LOCALIDAD);
    const nuevoEstatus = normalizeText(row?.NUEVO_ESTATUS);
    const estatusPortalQ = normalizeText(row?.ESTATUS_PORTAL_Q);

    const isEntregadoPortalLiberado = (
      nuevoEstatus === "entregado"
      && estatusPortalQ === "liberado"
    );
    const isPortalCancelado = estatusPortalQ === "cancelado";

    return isQualitasXnuupAseguradora(aseguradora)
      && localidad === localidadNormalizada
      && !isEntregadoPortalLiberado
      && !isPortalCancelado;
  });

  return defaultSortRows(filtered);
};

export const QualitasXnuupLocalPage = createPendientesPage({
  pageTitle: "QUALITAS/XNUUP LOCAL",
  pageSubtitle: "Registros correspondientes a QUALITAS/XNUUP LOCAL.",
  filterBaseRows: (rows) => filterQualitasXnuupRows(rows, "local"),
  exportFilePrefix: "qualitas-xnuup-local",
  exportSheetName: "QUALITAS XNUUP LOCAL",
  columnVisibilityStorageKey: "baseDatosColumnVisibility-qualitas-xnuup-local",
  columnFieldOrder: [
    "NUEVO_ESTATUS",
    "ESTATUS_PORTAL_Q",
    "ESTATUS_LOCAL",
    "ESTATUS_FORANEO",
    "ESTATUS2"
  ],
  hiddenColumnFields: ["ESTATUS3"],
  additionalEditableFields: ["OBSERVACION_CHOFER", "BACK_ORDER", "PEDIDO", "OC"],
  fieldEditRoles: {
    OBSERVACION_CHOFER: ["chofer", "supervisor"],
    BACK_ORDER: ["supervisor"],
    OC: ["supervisor", "captura"]
  },
  selectFieldOptions: ESTATUS2_SELECT_FIELD_OPTIONS
});

export const QualitasXnuupForaneoPage = createPendientesPage({
  pageTitle: "QUALITAS/XNUUP FORÁNEO",
  pageSubtitle: "Registros correspondientes a QUALITAS/XNUUP FORÁNEO.",
  filterBaseRows: (rows) => filterQualitasXnuupRows(rows, "foraneo"),
  exportFilePrefix: "qualitas-xnuup-foraneo",
  exportSheetName: "QUALITAS XNUUP FORANEO",
  columnVisibilityStorageKey: "baseDatosColumnVisibility-qualitas-xnuup-foraneo",
  columnFieldOrder: [
    "NUEVO_ESTATUS",
    "ESTATUS_PORTAL_Q",
    "ESTATUS_LOCAL",
    "ESTATUS_FORANEO",
    "ESTATUS2"
  ],
  hiddenColumnFields: ["ESTATUS3"],
  additionalEditableFields: ["OBSERVACION_CHOFER", "BACK_ORDER", "PEDIDO", "OC"],
  fieldEditRoles: {
    OBSERVACION_CHOFER: ["chofer", "supervisor"],
    BACK_ORDER: ["supervisor"],
    OC: ["supervisor", "captura"]
  },
  selectFieldOptions: ESTATUS2_SELECT_FIELD_OPTIONS
});

export default QualitasXnuupLocalPage;
